import { AccuracyProviderDetail } from "@app/projects/results/accuracy";
import InspectionProfileTableData from "./inspectionProfileTableData";
import generateDefaultProviderPanelRow from "./defaultProviderPanelRow";
import { TooltipWrapper } from "@app/shared";
import { getLocationConfidenceTooltip } from "../../../network-assessment/accuracy/AccuracyInspectionWaffleTooltips";

/* eslint-disable sort-keys */
export const generateLocationConfidenceScoreRow = (rowKey: string, title: string, sourceRecord: AccuracyProviderDetail): InspectionProfileTableData => {
  const locationConfidenceScoreData = generateDefaultProviderPanelRow(rowKey, title, null, sourceRecord.inspectionSupplement.practitionerAtLocationConfidence);
  locationConfidenceScoreData.source = null;
  locationConfidenceScoreData.result = sourceRecord.inspectionSupplement.practitionerAtLocationConfidence
    ? <> {sourceRecord.inspectionSupplement.practitionerAtLocationConfidence.value}
      <TooltipWrapper text={getLocationConfidenceTooltip(sourceRecord.inspectionSupplement.practitionerAtLocationConfidence.value)}>
        &nbsp;<i className="fa fa-info-circle align-top" />
      </TooltipWrapper></>
    : locationConfidenceScoreData.result;
  return locationConfidenceScoreData;
}